// One translation text the editor has confirmed written to the DB (manual
// save or AI fill) — what owners need to patch the cached catalog with,
// instead of refetching the whole thing.
export type SavedTranslationText = {
  LanguageCode: string
  Name: string
  Description: string | null
}

// Draft state for one language inside the inline row editor. `cur*` is the
// editable current text (source for Save), `base*` the text as loaded (to
// detect real changes), `ai*` the on-demand suggestion plus the critic's
// verdicts.
export type LangEdit = {
  curName: string
  curDesc: string
  baseName: string
  baseDesc: string
  aiName: string
  aiDesc: string
  aiConfidence: string
  aiNote: string | null
  isImprovement: boolean
  isConsistent: boolean
  evalNote: string | null
}

export function blankEdit(name: string, desc: string): LangEdit {
  return {
    curName: name,
    curDesc: desc,
    baseName: name,
    baseDesc: desc,
    aiName: "",
    aiDesc: "",
    aiConfidence: "",
    aiNote: null,
    isImprovement: true,
    isConsistent: true,
    evalNote: null,
  }
}

// True when the operator has typed something different from what was loaded
// — the guard for "is there anything Save would actually write."
export function isDirty(edit: LangEdit): boolean {
  return edit.curName !== edit.baseName || edit.curDesc !== edit.baseDesc
}

// A real, different suggestion exists for this language.
export function hasSuggestion(edit: LangEdit): boolean {
  return (
    edit.aiName !== "" &&
    (edit.aiName !== edit.baseName || edit.aiDesc !== edit.baseDesc)
  )
}

// Only a faithful (critic-consistent), different suggestion is savable;
// identical or inconsistent ones are suppressed in the UI and must not
// count toward Save all.
export function isSavable(edit: LangEdit): boolean {
  return hasSuggestion(edit) && edit.isConsistent
}
